const zipCodes = require('twzipcode-data/dist/zh-tw/zipcodes');

module.exports = zipCodes.reduce((result, row) => {
    const { zipcode, county, city } = row;
    return { ...result, [`${zipcode}`]: `${county} ${city}` };
});
